import { render, staticRenderFns } from "./newAttributeConfig.vue?vue&type=template&id=21a774ea&scoped=true"
import script from "./newAttributeConfig.vue?vue&type=script&lang=js"
export * from "./newAttributeConfig.vue?vue&type=script&lang=js"
import style0 from "./newAttributeConfig.vue?vue&type=style&index=0&id=21a774ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a774ea",
  null
  
)

export default component.exports